module.exports = __webpack_public_path__ + "static/media/check.2260e973.svg";